<template>
  <div class="part-four">
    <div class="title">
      <div style="font-size: 40px; color: #091221; font-weight: bold">
        赋能企业数字化转型营销服务
      </div>
      <div style="font-size: 24px; color:#404040; margin-top: 30px;margin-bottom: 60px;">
        为企业提供全流程数字化营销服务
      </div>
    </div>
    <div class="main-content">
      <div class="main-content-left">
        <div class="main-content-left-top">
          <img :src="require('../assets/image_1/528_2.png')" />
          <div class="icon-tips">供应链货盘服务</div>
          <div class="fz-20 c-404040 text-left">整合优质产品资源，解决企业货源不稳定采购成本高的问题，实现快速选品。</div>
          <div class="flex-center">
            <div class="data-box">
              <div class="c-007EFF fz-22">300000+</div>
              <div class="main-color fz-18 mt-10">商品数量（SKU）</div>
            </div>
            <div class="data-box">
              <div class="c-007EFF fz-22 ">10000+</div>
              <div class="main-color fz-18 mt-10">品牌在线</div>
            </div>
            <div class="data-box">
              <div class="c-007EFF fz-22">含专票供货</div>
              <div class="main-color fz-18 mt-10">保证合规运营</div>
            </div>
            <div class="data-box">
              <div class="c-007EFF fz-22">无限选品</div>
              <div class="main-color fz-18 mt-10">货源同步一键代发</div>
            </div>

          </div>
        </div>
        <div class="main-content-left-bottom">
          <div class="left"> <img :src="require('../assets/image_1/531_2.png')" />
            <div class="icon-tips">营销策划服务</div>
            <div class="fz-20 c-404040 text-left" style="line-height: 30px;">
              提供企业线上营销方案，解决获客难、转化低的问题，实现精准触达、品牌曝光和销售业绩持续增长。</div>
          </div>
          <div class="right"> <img :src="require('../assets/image_1/533_2.png')" />
            <div class="icon-tips">技术基础服务</div>
            <div class="fz-20 c-404040 text-left" style="line-height: 30px;">
              保障系统稳定安全运行，解决技术运维能力不足的问题，实现高效部署、故障预警和业务连续性管理。</div>
          </div>
        </div>
      </div>
      <div class="main-content-right">
        <div class="main-content-right-top">
          <img :src="require('../assets/image_1/270.png')" />
          <div class="icon-tips">定制开发服务</div>
          <div class="fz-20 c-404040 text-left" style="line-height: 30px;">根据企业需求个性化开发系统，解决标准化软件功能不匹配的问题。</div>
        </div>
        <img :src="require('../assets/image_1/271.png')" />
      </div>
    </div>
    <!-- <div class="logo-list">
       <div class="logo-item" v-for="(item,index) in list" :key="index" @click="changeActive(index)">
           <img :src="item.img" alt="">
           <div :class="{'logo-item-title':true,'actives': index == activeIndex}">{{item.title}}</div>
           <div v-if="index == activeIndex" style="width: 133px;height: 8px;background: #203DF5;border-radius: 25px;position: relative;top: 22px;left: 17px;"></div>
       </div>
    </div>
     <div class="line" >
     </div>
     <div class="bottom">
       <div>
         <div class="bottom-title">{{activeBottom.title}}</div>
         <div class="bottom-des">{{activeBottom.des1}}</div>
         <div class="bottom-des2">{{activeBottom.des2}}</div>
         <div class="bottom-button" @click="openDialog">点击领取</div> 
       </div>
       <img :src="activeBottom.img" alt="" style="margin-left:44px">
     </div> -->
  </div>
</template>

<script>
export default {
  data() {
    return {
      list: [
        {
          img: require('../assets/part-four-logo1.png'),
          title: '帮您全景曝光'
        },
        {
          img: require('../assets/part-four-logo2.png'),
          title: '帮您留住客户'
        },
        {
          img: require('../assets/part-four-logo1.png'),
          title: '帮您转化成交'
        }
      ],
      activeIndex: 0,
      activeBottom: {},
      bottomList: [
        {
          img: require('../assets/part-four-img1.png'),
          title: '多渠道展示商品 打开销路',
          des1: '链接14亿微信用户，在微信生态中曝光',
          des2: "商品，让商品直接触达用户，收割14亿微信流量红利"
        },
        {
          img: require('../assets/part-four-img2.png'),
          title: '多行业多场景 多点爆破',
          des1: '200+种营销功能自由组合使用，搭配不',
          des2: "同的场景及营销计划，玩法更新颖，效果更明显"
        },
        {
          img: require('../assets/part-four-img3.png'),
          title: '全链路私域营销 策略加持',
          des1: '用权益把流量变成留量，把用户变成忠实',
          des2: '粉丝，撬动资源持续创造收益，真正做到降本增效'
        },
      ]
    };
  },

  methods: {
    changeActive(index) {
      this.activeIndex = index
      this.activeBottom = this.bottomList[index]
    },
    openDialog() {
      this.$emit('openDialog')
    }
  },

  components: {},
  created() {
    this.activeBottom = this.bottomList[this.activeIndex]
  }
};

</script>
<style scoped lang="scss">
.part-four {
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  padding: 130px 50px 130px;

  .main-color {
    color: #404040;
  }

  .fz-18 {
    font-size: 18px;
  }

  .mt-10 {
    margin-top: 10px;
  }

  .fz-22 {
    font-size: 22px;
  }

  .c-007EFF {
    color: #007EFF;
  }

  .data-box {
    width: 161px;
    height: 89px;
    border-radius: 8px 8px 8px 8px;
    display: flex;
    flex-direction: column;
    padding-left: 10px;
    padding-top: 20px;
    justify-content: flex-start;
    margin-top: 30px;
  }

  .main-content-right {
    width: 415px;
    height: 744px;
    background: #FFFBFB;
    border-radius: 8px 8px 8px 8px;
  }

  .text-left {
    text-align: left;
  }

  .fz-20 {
    font-size: 20px;
  }

  .c-404040 {
    color: #404040;
  }

  .title {
    text-align: center;
    line-height: 1;
  }

  .main-content-left-bottom {
    display: flex;

    .left {
      margin-right: 15px;
      background-color: #FFF9F5;
    }

    .right {
      margin-left: 15px;
      background-color: #E9F9F9;
    }

    .left,
    .right {
      width: 363px;
      height: 354px;
      border-radius: 8px 8px 8px 8px;
      padding: 40px 25px 0;
    }
  }

  .icon-tips {
    text-align: left;
    font-weight: bold;
    font-size: 24px;
    color: #091221;
    line-height: 1;
    margin: 30px 0;
  }

  .main-content-right {
    padding-top: 40px;
    padding-left: 24px;
    width: 415px;
    height: 744px;
    background: #F3F3FF;
    border-radius: 8px 8px 8px 8px;
  }

  .main-content-right-top {
    margin-bottom: 31px;

    .icon-tips {
      text-wrap: wrap;
    }
  }

  .main-content-left {
    margin-right: 50px;
  }

  .main-content {
    display: flex;

    .main-content-left-top {
      height: 360px;
      background: #F3FAFF;
      box-sizing: border-box;
      padding-top: 40px;
      padding-left: 24px;
      border-radius: 8px 8px 8px 8px;
      margin-bottom: 30px;
    }
  }

  .main-content-left-botton {
    display: flex;
  }
}

.logo-list {
  display: flex;
  margin-top: 100px;
}

.logo-item {
  text-align: center;
  cursor: pointer;
}

.logo-item:nth-child(2) {
  margin: 0 250px;
}

.logo-item-title {
  margin-top: 20px;
  font-size: 28px;
  font-weight: bold;
}

.actives {
  color: #203DF5;
}

.line {
  margin-top: 18px;
  width: 1200px;
  height: 2px;
  background: #203DF5;
  border-radius: 0px 0px 0px 0px;
  opacity: 0.2;
}

.bottom {
  margin-top: 20px;
  display: flex;
  height: 500px;
}

.bottom img {
  object-fit: contain;
}

.bottom-title {
  margin-top: 114px;
  color: #000000;
  font-size: 40px;
  font-weight: bold;
}

.bottom-des {
  margin-top: 30px;
  color: #000000;
  font-size: 24px;
}

.bottom-des2 {
  color: #000000;
  font-size: 24px;
}

.bottom-button {
  background-color: #203DF5;
  border-radius: 30px;
  font-size: 28px;
  font-weight: bold;
  padding: 10px 44px;
  color: #ffffff;
  width: 112px;
  margin-top: 53px;
  cursor: pointer;
}

.bottom-button:hover {
  opacity: 0.6;
}
</style>